import { useState } from "react";
import { Row } from "react-bootstrap";
import PropTypes from "prop-types";
import { toast } from "react-toastify";
import { useIntl } from "react-intl";

import Column from "components/atoms/Column/Column";
import Alert from "components/v2/Alert/Alert";
import Button from "components/v2/Button/Button";
import errorToast from "helpers/errorToast";
import { ignoreRequestToCancel } from "api";

interface ICancelRequestProps {
  setShowCancelDialog: Function;
  shipmentId: string;
  isRequest: boolean;
  QuickRequestDetails: any;
  loadingData: boolean;
  canCancel: boolean;
}

function CancelRequestBanner(props: ICancelRequestProps) {
  const { setShowCancelDialog, shipmentId, isRequest, QuickRequestDetails, loadingData, canCancel } = props;
  const intl = useIntl();
  const user = QuickRequestDetails[0]?.quick_requestor;

  const [requestIgnored, setRequestIgnored] = useState(false);

  const onIgnoreRequestToCancel = () => {
    ignoreRequestToCancel(shipmentId)
      .then(() => {
        setRequestIgnored(true);
        setShowCancelDialog(false);
        toast("Cancellation request dismissed", { type: "success" });
      })
      .catch((err) =>
        errorToast(
          err,
          intl.formatMessage({
            id: "shipment-quotes.components.cancelRequestBanner.couldNotIgnoreRequest",
            defaultMessage: "Could not ignore request. Please try again later.",
          }),
        ),
      );
  };

  if (requestIgnored) return null;
  if (!loadingData && isRequest && QuickRequestDetails[0]?.has_requested_cancellation && canCancel) {
    return (
      <Column>
        <Row>
          <div className="mb-xl w-100">
            <Alert
              variant="warning"
              label={intl.formatMessage(
                {
                  id: "shipment-quotes.components.cancelRequestBanner.quickRequestorRequestCancel",
                  defaultMessage: "Quick requestor {name} ({email}) requested to cancel this quote request.",
                },
                { name: user?.name, email: user?.email },
              )}
            >
              <div className="d-flex mt-lg">
                <Button
                  className="mr-lg"
                  variant="secondary-gray"
                  label={intl.formatMessage({
                    id: "ignoreRequestToCancel",
                    defaultMessage: "Ignore",
                  })}
                  onClick={onIgnoreRequestToCancel}
                />
                <Button
                  variant="destructive-primary"
                  label={intl.formatMessage({
                    id: "shipment-quotes.components.cancelRequestBanner.cancelQuoteRequest",
                    defaultMessage: "Cancel quote request",
                  })}
                  onClick={() => setShowCancelDialog(true)}
                />
              </div>
            </Alert>
          </div>
        </Row>
      </Column>
    );
  }
  return <div />;
}

CancelRequestBanner.propTypes = {
  setShowCancelDialog: PropTypes.func.isRequired,
  shipmentId: PropTypes.string.isRequired,
  isRequest: PropTypes.bool.isRequired,
  QuickRequestDetails: PropTypes.instanceOf(Object).isRequired,
  loadingData: PropTypes.bool.isRequired,
  canCancel: PropTypes.bool.isRequired,
};

export default CancelRequestBanner;
